export const UPLOAD_LIMIT = 2;
export const UPLOAD_FILE_SIZE_LIMIT = 2097152; // Only allow 2mb image max
export const UPLOAD_FILE_SIZE_LIMIT_MESSAGE =
  "Image is too large. Images must be less than 2mb. Please reduce your image size and reupload";
export const UPLOAD_LIMIT_MESSAGE =
  "Single upload Limit Reached. Please batch your uploads";
export const UPLOAD_DUPLICATE_MESSAGE =
  "Duplicate File Found, A file with the same name was already added.";
